<template>
    <div class="form-group" >
        <select2 :disabled="field.disabled" v-model="field.value"  :multiple="field.type === 'multiselect'"  :name="field.name" class="attribute_select" :config="{placeholder: '', width: '100%'}" data-id="form-selectbox">
            <option value="">Choose....</option>
            <option v-for="option in field.options" :value="option.id" :data-id="`form-selectbox-option-${option.id}`">{{option.name}}</option>
        </select2>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    Vue.use(VueEvents)

    export default {
        name: 'form-input-text',
        props: ['FieldData'],
        components:{
        },
        data() {
            return {
                uiStates: {
                    message:"",
                    messageClass:"",
                },
                field: this.FieldData,
            }
        },
        mounted() {
            this.$emit('input', this.field.value);
        },
        created() {

        },
        watch: {

        },
        methods: {

        }
    };
</script>

<style scoped lang="scss">
    .required-field{
        font-size: 16px;
        color: #AB5755;
        position: absolute;
        top: -4px;
    }
    label{
        position: relative;
    }
</style>

<style lang="scss">
    .select2-container.select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-selection__choice{
        background-color: #3F759E !important;
        border-color: #3F759E !important;
        font-size:12px !important;
        color:#fff;
    }
    .select2-container.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{
        color:#fff !important;
    }
</style>
